import { Observable } from "rxjs";
import { EPackageType } from "../enum/e-package-type";
import { Package } from "../models/package";
import { Injectable, Injector } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export abstract class PackageService {

    constructor(
        public injector: Injector
    ) {

    }

    public abstract getPackages(discriminator : EPackageType): Observable<Package[]>;
    
    public abstract getPackage(packageId : number): Observable<Package>;
      
    public abstract createPackage(pack: Package): Observable<Package>;

    public abstract deletePackage(pack: Package): Observable<number> ;

    public abstract editPackage(pack: Package): Observable<any> ;

}
  